import { inject, NewInstance } from 'aurelia-framework';
import { StageService } from 'pages/system-fields/stages/service';
import { ProcessService } from 'pages/standard-setup/processes/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogService } from 'aurelia-dialog';
import { DialogController } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), StageService, EventAggregator, DialogService, ProcessService)
export class StageEditor {
    constructor(controller, validationController, stageService, ea, dialogService, processService) {
        this.controller = controller;
        this.dialogService = dialogService;
        this.stageService = stageService;
        this.processService = processService;
        this.ea = ea;
        this.stage = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('name').required()
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.stage = await this.stageService.getById(model.id);
        }
    }

 

    addProcess() {
        this.dialogService.open({ viewModel: this.processService.editor });
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.stage.id) {
                    await this.stageService.update(this.stage);
                    toastr.success('Stage was updated!');
                } else {
                    await this.stageService.create(this.stage);
                    toastr.success('New stage was created!');
                }
                this.ea.publish('stages:updated', this.stage);
                this.controller.ok(this.stage);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}